export const SpeakersDataLoaded = (data,home = false) => ({
    type: 'SPEAKERS_DATA_LOADED',
    payload : data
})